import { Link } from 'react-router-dom'
import Header from '../Header'
import Footer from '../Footer'



import './inhouseworkshops.sass'

const InHouseWorkshops = () => {

   
    return (

        <main className='inhouseworkshops'>
            <Header />
            <div className='container'>
                <h1 className='title'>
                    Our In-House Programs Customized to Meet Your Unique Needs
                </h1>
                <h4 className='title title--sm'>
                    <Link to='/public-workshops' title='Learn more about public workshops'>
                    Public Service Academy
                    </Link>
                </h4>
                <ul className='list lis--unordered'>
                    <li>Professionalism in the Workplace: <i>Building a Workplace of Mutual Respect</i></li>
                    <li>Customer Service in the Public Sector - <i>Staying Courteous Under Pressure</i></li>
                    <li>Resolving Conflict in the. Workplace: <i>Helping Employees to Get Along</i></li>
                    <li>Being a Great Employee & Team Player: <i>Achieving Personal & Collaborative Success at Work</i></li>
                    <li>Managing Your Time, Priorities & Work/Life Balance: <i>Thriving Personally & Professionally</i></li>
                </ul>

                <h4 className='title title--sm'>
                    Leadership Series
                </h4>
                <ul className='list lis--unordered'>
                    <li>Supervision - <i>The Academy</i></li>
                    <li>Management – <i>The Academy</i></li>
                    <li>Leadership – <i>The Academy</i></li>
                    <li>Preparing for Supervision - <i>The Workshop</i></li>
                    <li>Improving Employee Performance – <i>Dealing with Unacceptable Employee Behavior</i></li>
                    <li>Building High Performance Work Teams</li>
                   <li> Public Service Ethics</li>
                    <li>Business Not as Normal - Our Public Image: <i>The Leader's Role</i></li>
                    <li>Conducting Effective Performance Evaluations & Appraisals</li>
                    <li>Managing Change & Public Service Ethics</li>
                </ul>


                <h4 className='title title--sm'>
                    Creating a Future of Your Choice & Career Development Series
                </h4>
                <ul className='list lis--unordered'>
                    <li>Self-Advocacy: <i>Working With the Difficult Boss</i></li>
                    <li>Deliver the Winning Interview: <i>Stand Out In The Crowd </i></li>
                    <li>Strategic Planning: <i>Building Mission, Vision and Values</i></li>
                    <li>Selecting Winners - <i>Interviewing & Hiring the Best</i></li>
                    <li>Self-Managed Career Development: <i>Job/Person/Environment Assessment</i></li>
                    <li>Making Effective Presentations – <i>To the Boss, To Council & To the Public</i></li>
                </ul>
            </div>
            <Footer />
        </main>

    )
}

export default InHouseWorkshops